var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExchange(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.854 13.354l4-4a.5.5 0 00-.707-.707L5 11.793V1a.5.5 0 10-1 0v10.793L.854 8.647a.5.5 0 00-.707.707l4 4a.5.5 0 00.707 0zM15.146.646l-4 4a.5.5 0 00.707.707L15 2.207V13a.5.5 0 101 0V2.207l3.146 3.146a.5.5 0 00.707-.707l-4-4a.5.5 0 00-.707 0z",
    fill: "#000"
  })));
}
SvgExchange.displayName = 'Exchange';
export default SvgExchange;